import { Link } from "react-router-dom";

import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import BlogCard from "../BlogCard";
import { siteSections } from "../../../content/siteSections";

/**
 * Homepage preview of the latest blog posts.
 * Translation: Homepage preview of the latest blog posts.
 *
 * @param {{posts: Array<Object>}} props - Blog preview props.
 * @returns {JSX.Element} Preview section.
 */
const BlogPreview = ({ posts }) => (
  <section id="blog" className="section-block section-block--with-divider">
    <div className="section-shell">
      <SectionHeading
        eyebrow={siteSections.blog.eyebrow}
        title={siteSections.blog.title}
        description={siteSections.blog.description}
      />

      <div className="card-grid card-grid--three">
        {posts.map((post, index) => (
          <Reveal key={post.slug} delay={index * 100}>
            <BlogCard post={post} />
          </Reveal>
        ))}
      </div>

      <Reveal className="section-footer-cta">
        <Link
          to="/blog"
          className="button button-secondary button--ghost"
          title="View all engineering insights on our blog"
        >
          {siteSections.blog.ctaLabel}
        </Link>
      </Reveal>
    </div>
    <div className="glow-line section-block__divider" />
  </section>
);

export default BlogPreview;
